module.exports = __webpack_public_path__ + "media/images/athletes/2189-337157ab50a48b6112ddff44f17a5e6f.png";